export default String.raw`
.comparison {
    &__bar {
        padding: 16px;
        > .secondary-action-button {
            width: 40px;
            height: 40px;
            order: 2;
            flex-shrink: 0;
            flex-grow: 0;
            padding: 0;

            > span {
                display: none;
            }
        }

        .comparison__items {
            margin-right: auto;
            flex-wrap: wrap;
        }
    }
}

`